import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

import { addImage, updateImage } from 'FD/images/actions';
import {
  notifySuccessAction,
  notifyErrorAction,
} from '../../../common/actions/notifications';

@injectIntl
@connect()
export default class AddToFootdataDialog extends Component {
  state = {
    description: '',
    name: '',
    alt: '',
    sourceOfPurchase: '',
    copyright: '',
    submitting: false,
  };

  handleField = field => e => {
    this.setState({ [field]: e.target.value });
  };

  onSubmit = async () => {
    const { dispatch, blob, filename, onClose } = this.props;
    const {
      description,
      name,
      alt,
      sourceOfPurchase,
      copyright,
    } = this.state;
    const trimmedDescription = description.trim();
    if (!trimmedDescription) return;
    this.setState({ submitting: true });
    try {
      const file = new File([blob], filename, { type: 'image/jpeg' });
      const addAction = await dispatch(
        addImage({ file, filename, description: trimmedDescription })
      );
      if (!addAction || !addAction.payload || !addAction.payload.id) {
        throw new Error('Upload failed');
      }
      const id = addAction.payload.id;
      const optionalPayload = {};
      if (name.trim()) optionalPayload.name = name.trim();
      if (alt.trim()) optionalPayload.alt = alt.trim();
      if (sourceOfPurchase.trim()) optionalPayload.sourceOfPurchase = sourceOfPurchase.trim();
      if (copyright.trim()) optionalPayload.copyright = copyright.trim();
      if (Object.keys(optionalPayload).length > 0) {
        try {
          await dispatch(updateImage(id, optionalPayload));
        } catch (_) {
          // The image is created — surface a soft error but still treat as success.
        }
      }
      dispatch(notifySuccessAction('tools_imageResize_dialog_success'));
      this.setState({
        description: '',
        name: '',
        alt: '',
        sourceOfPurchase: '',
        copyright: '',
        submitting: false,
      });
      onClose();
    } catch (err) {
      dispatch(notifyErrorAction('tools_imageResize_dialog_error'));
      this.setState({ submitting: false });
    }
  };

  render() {
    const { open, onClose, intl: { messages: m } } = this.props;
    const {
      description,
      name,
      alt,
      sourceOfPurchase,
      copyright,
      submitting,
    } = this.state;
    const canSubmit = description.trim().length > 0 && !submitting;

    return (
      <Dialog
        open={open}
        onClose={submitting ? undefined : onClose}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>{m.tools_imageResize_dialog_title}</DialogTitle>
        <DialogContent>
          <TextField
            label={m.field_description}
            value={description}
            onChange={this.handleField('description')}
            helperText={m.tools_imageResize_dialog_descriptionHelper}
            multiline
            rows={2}
            fullWidth
            required
            margin="dense"
            disabled={submitting}
          />
          <TextField
            label={m.field_name}
            value={name}
            onChange={this.handleField('name')}
            fullWidth
            margin="dense"
            disabled={submitting}
          />
          <TextField
            label={m.field_alt}
            value={alt}
            onChange={this.handleField('alt')}
            fullWidth
            margin="dense"
            disabled={submitting}
          />
          <TextField
            label={m.field_sourceOfPurchase}
            value={sourceOfPurchase}
            onChange={this.handleField('sourceOfPurchase')}
            fullWidth
            margin="dense"
            disabled={submitting}
          />
          <TextField
            label={m.field_copyright}
            value={copyright}
            onChange={this.handleField('copyright')}
            fullWidth
            margin="dense"
            disabled={submitting}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={submitting}>
            {m.tools_imageResize_dialog_cancel}
          </Button>
          <Button
            onClick={this.onSubmit}
            color="primary"
            variant="contained"
            disabled={!canSubmit}
          >
            {submitting ? (
              <CircularProgress size={20} />
            ) : (
              m.tools_imageResize_dialog_submit
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
